/**
 * MealAnalysisErrorBoundary — bouclier React qui empêche tout crash du
 * rendu de l'analyse de causer un écran noir global. Affiche un message
 * de fallback proprement et reset au prochain mount.
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { AlertTriangle, X } from 'lucide-react';
import ErrorLogger from '../utils/errorLogger';

class MealAnalysisErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[SCAN] 💥 ErrorBoundary capturé', { error, info });
    try {
      ErrorLogger.log(error, 'Meal_Analysis_Render_Crash', {
        component_stack: info?.componentStack,
        severity: 'CRITICAL',
      });
    } catch { /* never let logger crash UI */ }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (typeof this.props.onReset === 'function') {
      this.props.onReset();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Dialog open={true} onOpenChange={() => this.handleReset()}>
          <DialogContent className="bg-card border-amber-500/40 max-w-md" data-testid="scan-crash-fallback">
            <DialogHeader>
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-3 rounded-full bg-amber-500/20 border-2 border-amber-500/40">
                <AlertTriangle className="w-8 h-8 text-amber-400" />
              </div>
              <DialogTitle className="text-center font-heading text-xl uppercase tracking-tight">
                Analyse difficile
              </DialogTitle>
              <DialogDescription className="text-center text-sm leading-relaxed pt-2">
                On a rencontré un petit accroc en affichant ton analyse. Réessaie dans un instant — tes données sont saines, on n'a rien perdu.
              </DialogDescription>
            </DialogHeader>
            <Button
              onClick={this.handleReset}
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-bold mt-4"
              data-testid="scan-crash-retry"
            >
              <X className="w-4 h-4 mr-2" />
              Fermer et réessayer
            </Button>
          </DialogContent>
        </Dialog>
      );
    }
    return this.props.children;
  }
}

export default MealAnalysisErrorBoundary;
